import type { HintLevel } from '@codeframe/lang-core';
import { usePlayer } from '../api/hooks.js';

export function useHintLevel(): HintLevel {
  return usePlayer()?.settings.hintLevel ?? 'beginner';
}

export function useFeature(id: string): { unlocked: boolean; minLevel: number; name: string } {
  const f = usePlayer()?.features.find((x) => x.id === id);
  return { unlocked: f?.unlocked ?? false, minLevel: f?.minLevel ?? 1, name: f?.name ?? id };
}
